import { Component, input } from '@angular/core';
import { IconKlankvoetStom } from '../../icons/i-klankvoet-stom';
import { RidAlgorithmCard } from '../rid-algorithm-card/rid-algorithm-card';
import { RidKlankCard } from '../rid-klank-card/rid-klank-card';
import { RidSpacer } from '../rid-spacer/rid-spacer';
import { RidSyllabicCard } from '../rid-syllabic-card/rid-syllabic-card';
import { TKey } from '../rid-syllabic-keyboard/rid-syllabic-keyboard.utils';
import { RidSyllabicTextInput } from '../rid-syllabic-text-input/rid-syllabic-text-input';
import { RidVerticalSpacer } from '../rid-vertical-spacer/rid-vertical-spacer';

@Component({
  selector: 'rid-algorithm-stomme-voet',
  imports: [RidSyllabicTextInput, RidKlankCard, RidVerticalSpacer, RidSyllabicCard, RidAlgorithmCard, IconKlankvoetStom, RidSpacer],
  templateUrl: './rid-algorithm-stomme-voet.html',
  host: {
    class: 'grid place-items-center',
  },
})
export class RidAlgorithmStommeVoet {
  mode = input.required<'ICON' | 'AS_INPUT'>();
  voet = input.required<{ content: TKey[]; hasDubbelzetter: boolean }>();
  isCurrent = input.required<boolean>();
}
